import { createApp } from 'vue'
import { createHead } from '@unhead/vue/client'
import App from './App.vue'
import router from './router'

import './assets/styles/global.css'

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
  components,
  directives,
})

const app = createApp(App)
const head = createHead()

const structuredData = {
  "@context": "https://schema.org",
  "@type": "Event",
  "name": "Mariage d'Elyne et Benoit", 
  "description": "Rejoignez-nous pour célébrer notre union le 24 avril 2027.",
  "startDate": "2027-04-24T14:00:00+02:00",
  "endDate": "2027-04-25T15:00:00+02:00",
  "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
  "location": {
    "@type": "Place",
    "name": "Abbaye de Fontdouce",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Preguillac",
      "addressRegion": "Charente-Maritime",
      "addressCountry": "FR"
    }
  },
  "image": [
    "https://www.elyneetbenoit.fr/WebSiteIcon.png" , 
    "https://www.elyneetbenoit.fr/photo-couple.jpg", 
    "https://www.elyneetbenoit.fr/photo-couple-two.jpg" 
  ],
  "isAccessibleForFree": false
}

const script = document.createElement('script')
script.type = 'application/ld+json'
script.textContent = JSON.stringify(structuredData)
document.head.appendChild(script)

app.use(head)
app.use(router)
app.use(vuetify) // On utilise app.use pour chaque plugin proprement

app.mount('#app')
